import React from 'react';
import { Card } from '../SubscriptionAppCard';
import { contactTopProducts } from '../../data/mockContactOverview';
import { formatShortDate } from '../../utils/dateFormat';

// The products this contact buys most, for quick reference on a call
export function TopProductsCard() {
  return <Card padding="none" data-id="element-1738" data-mp="20viiyw474n5o">
      <div className="p-6 border-b border-[#E2E8F0] bg-gradient-to-r from-[#F8FAFC] to-white" data-id="element-1739" data-mp="20wae65tvsivf">
        <h3 className="text-xl font-semibold text-[#0F172A]" data-id="element-1740" data-mp="2yhzd5shmukn7">Top Products</h3>
      </div>
      <div className="bg-white rounded-b-lg overflow-x-auto" data-id="element-1741" data-mp="2tjo3bhrc8a4z">
        <table className="w-full text-sm" data-id="element-1742" data-mp="2tmad7o1pb1qd">
          <thead data-id="element-1743" data-mp="2os62ctpbe9k0">
            <tr className="border-b border-[#E2E8F0] bg-[#F8FAFC]" data-id="element-1744" data-mp="2ormvq95477la">
              <th scope="col" className="px-6 py-2.5 text-left text-xs font-semibold text-[#64748B] uppercase tracking-wider" data-id="element-1745" data-mp="2juwgtp51qi1g">
                Product title
              </th>
              <th scope="col" className="px-4 py-2.5 text-right text-xs font-semibold text-[#64748B] uppercase tracking-wider" data-id="element-1746" data-mp="3cis82ebujhqu">
                Times ordered
              </th>
              <th scope="col" className="px-6 py-2.5 text-right text-xs font-semibold text-[#64748B] uppercase tracking-wider" data-id="element-1747" data-mp="klsbpasstpew">
                Last ordered
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#F1F5F9]" data-id="element-1748" data-mp="as1qceryxv3f">
            {contactTopProducts.map(product => <tr key={product.id} className="hover:bg-[#F8FAFC] transition-colors" data-id="element-1749" data-mp="fquxzqkkqrvo">
                <td className="px-6 py-3 font-medium text-[#0F172A]" data-id="element-1750" data-mp="udlgw0nf77j">
                  {product.title}
                </td>
                <td className="px-4 py-3 text-right text-[#0F172A] font-medium" data-id="element-1751" data-mp="3o0eb2zz3kpcm">
                  {product.timesOrdered}
                </td>
                <td className="px-6 py-3 text-right text-[#475569] whitespace-nowrap" data-id="element-1752" data-mp="3t0iryr3x3m3d">
                  {formatShortDate(product.lastOrdered)}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Card>;
}